export function canExportAnalytics(role: string | null | undefined): boolean {
  return role === "super_admin" || role === "org_admin";
}
